import { Vendor } from '../../Api/vendor';

export const vendorName = (vendor: Vendor) => {
  if (vendor.is_individual) {
    if (!vendor.first_name && !vendor.last_name) return '-';
    return `${vendor.first_name} ${vendor.last_name}`;
  }
  return vendor.company_name || vendor.legal_name || '-';
};
